import { useState, useEffect } from 'react';
import { FilePayload } from '@worknet/models';

import useChatStore from './useChatStore';

export function useFileAttachments(attachmentIds?: string[]) {
  const { getFileMetadata } = useChatStore();
  const [attachments, setAttachments] = useState<FilePayload[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    console.log('useFileAttachments hook called with IDs:', attachmentIds);

    if (!attachmentIds?.length) {
      console.log('No attachment IDs provided');
      setAttachments([]);
      return;
    }

    setLoading(true);
    setError(null);

    Promise.all(
      attachmentIds.map((id) =>
        getFileMetadata(id).catch((err) => {
          console.error(`Failed to load attachment ${id}:`, err);
          return {
            id,
            fileName: `File ${id.substring(0, 8)}...`,
            fileType: 'application/octet-stream',
            url: `/uploads/${id}`,
          } as FilePayload;
        })
      )
    )
      .then((results) => {
        setAttachments(results);
      })
      .catch((err) => {
        setError(err);
        console.error('Error loading attachments:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [attachmentIds, getFileMetadata]);

  return { attachments, loading, error };
}
